import Yinhai from './yinhai.vue'

export default Yinhai
